import { Card, CardBody, CardButtons, CardGrid, CardGridAmount, CardHeader, CardSubtitle, CardTitle, DetailsButton } from 'components';
import { formatDate } from 'functions';
import { useNavigation } from 'hooks';
import { PaymentSummary } from 'types';
import styles from './PaymentCard.module.scss';

type Props = {
    className?: string,
    paymentSummary: PaymentSummary
}

const PaymentCard = ({ paymentSummary }: Props) => {
    const { navigateToPayment } = useNavigation();
    const {
        adjustmentTotalAmount,
        dotPaymentStatus,
        paymentAmount,
        paymentDate,
        paymentIdRef,
        userVoucherDecimal,
        accountId,
        vendorId,
    } = paymentSummary;

    return (
        <Card className={styles.card}>
            <CardHeader>
                <CardTitle>
                    <span>Payment {paymentIdRef}</span>
                </CardTitle>
                {paymentDate &&
                    <CardSubtitle className={styles.subtitle}>
                            <span><strong>Vendor ID</strong>: {vendorId || 'Not Found'}</span>
                            <span><b>Sent</b>: {formatDate(new Date(paymentDate))}
                            {dotPaymentStatus === 'Voided' && <> &ndash; <strong>Voided</strong></>}
                        </span>
                    </CardSubtitle>            
                }
            </CardHeader>
            <CardBody>
                <CardGrid className={styles.grid}>
                    <CardGridAmount label="Invoiced" value={userVoucherDecimal} />
                    <CardGridAmount label="Adjustments" value={adjustmentTotalAmount} />
                    <CardGridAmount label="Paid" value={paymentAmount} />
                </CardGrid>
                <CardButtons>
                    <DetailsButton onClick={() => navigateToPayment(accountId as string, vendorId as string, paymentIdRef as string)} />
                </CardButtons>
            </CardBody>
        </Card>
    );
};

export default PaymentCard;